import React from 'react';
import PropTypes from 'prop-types';

import SeasonsButtonsBlock from 'components/filters/blocks/SeasonsButtonsBlock';

import ListItem from '../ListItem';
import styles from './styles.module.scss';

const MobileList = ({
	filters,
	filterList,
	filterOptions,
	resetOneFilter,
	onDatesChange,
	defaultFiltersValues,
	seasonsClassNameSetter,
	switchFilter
}) => {
	const keys = Object.keys(filterList);

	return (
		<div className={styles.MobileList}>
			{keys.map((key) => (
				<ListItem
					{...filterList[key]}
					key={key}
					defaultFiltersValues={defaultFiltersValues}
					resetOneFilter={resetOneFilter}
					selectedValue={filterOptions[key]}
					switchFilter={switchFilter}
				/>
			))}
			<SeasonsButtonsBlock
				setPeriod={onDatesChange}
				currentSeason={filters?.season}
				classNameSetter={seasonsClassNameSetter}
			/>
		</div>
	);
};

MobileList.propTypes = {
	filters: PropTypes.shape({
		season: PropTypes.string,
		locale: PropTypes.string,
		startDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
		endDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
		query: PropTypes.string
	}),
	onDatesChange: PropTypes.func,
	defaultFiltersValues: PropTypes.object,
	filterList: PropTypes.object,
	filterOptions: PropTypes.object,
	resetOneFilter: PropTypes.func,
	seasonsClassNameSetter: PropTypes.func,
	switchFilter: PropTypes.func
};

export default MobileList;
